<script>
  import DatePicker from '../../components/Flatpickr/DatePicker.svelte';
  let client = [
    { id: 1, text: 'Stacy' },
    { id: 2, text: 'Grace' },
    { id: 3, text: 'Jiyan' },
  ];
  let date;
  export let onBulkAction;
  export let selectedTasks = [];
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="setDueDate"
  tabindex="-1"
  aria-labelledby="setDueDateModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id="exampleModalLabel"
        >
          Set Due Date
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label
            for=""
            class="mb-3 color-lead">{selectedTasks.length} Tasks selected</label
          >
          <div class="row">
            <div class="col-md-4">
              <DatePicker
                on:change={(value) => {
                  date = value.detail[1];
                }}
                style="select-block select-border font-size-13 select-border w-100"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        <button
          type="button"
          class="btn btn-primary m-0 px-4 font-size-12"
          data-bs-dismiss="modal"
          on:click={() => {
            onBulkAction({
              comeFrom: 'dueDate',
              date,
            });
          }}>Save</button
        >
      </div>
    </div>
  </div>
</div>
